<template>
  <div class="ai-recommendations">
    <AiRecommendationsHead />
    <AiRecommendationsList />
  </div>
</template>

<script>
import AiRecommendationsHead from './ai-recommendations/ai-recommendations-head.vue'
import AiRecommendationsList from './ai-recommendations/ai-recommendations-list.vue'
export default {
  components: {
    AiRecommendationsHead,
    AiRecommendationsList

  }
}
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/vilocal/ai-recommendations.vue